import React from "react";
import "./PopeyeAttentionsCard.scss";
import { getIcon, getFlag } from '../../../../utils/images';
import { Tooltip } from 'antd';

const PopeyeAttentionsCard = ({update}) => {
  
  return (
    <div className="PopeyeAttentionCard">
      <div className="shipment-details">
        <div className="ship-number">
          <Tooltip title={update.shipping_line?.name}>
            <div className="logo">
              <img src={update.shipping_line?.icon || getIcon('logo-mini')} alt="logo" />
            </div>
          </Tooltip>
          {update.client_ref ? (
            <div className="sub-number">
              {`#${update.client_ref}`}
            </div>
          ) : update.booking_number ? (
            <div className="number">
              {`#${update.booking_number}`}
            </div>
          ) : update.bl ? (
            <div className="sub-number">
              {`#${update.bl}`}
            </div>
          ) : null}
        </div>
        <div className="ports">
          <img src={update.pol?.code ? getFlag(update.pol?.code) : getIcon('fetch', 'gif')} />
          <img src={getIcon('black-arrow')} />
          <img src={update.pol?.code ? getFlag(update.pod?.code) : getIcon('fetch', 'gif')} />
        </div>
      </div>
      <div className="attention-message">
        <p>{update.message}</p>
      </div>
    </div>
  );
}

export default PopeyeAttentionsCard;
